import { Text } from '@thanx/uikit/text'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import {
  match as MatchType,
  Route,
  Switch as RouterSwitch,
} from 'react-router-dom'
import CmsLayout from 'scenes/Cms/components/Cms.layout'
import ContentLayout from '../_shared/ContentLayout'
import BottomNav from './BottomNav'
import BottomNavEdit from './BottomNav/Edit'
import HamburgerNav from './HamburgerNav'
import { useAppNavigationInit } from './hooks'
import Style from './Style'
import NavConfirmModal from './_shared/NavConfirmModal'

type AppNavigationProps = {
  match?: MatchType<any>
}

const t = buildTranslate('cms.content.app_navigation')

export const AppNavigation: React.FC<AppNavigationProps> = ({ match }) => {
  // Initialize app navigation data (loads landing page theme to get theme ID)
  useAppNavigationInit()

  // Direct feature flag checks (not using the proxy hook here)
  const styleEnabled = useFlag('bottom-nav-toggle-mx', false)
  const hamburgerNavEnabled = useFlag('manage-hamburger-nav-mx', false)
  const bottomNavEnabled = useFlag('customise-bottom-nav-mx', false)

  // AppNavigation visibility - at least one tab must be enabled
  const isVisible = styleEnabled || hamburgerNavEnabled || bottomNavEnabled

  // If not visible, show not available message
  if (!isVisible) {
    return (
      <CmsLayout>
        <ContentLayout>
          <div className="text-center margin-top-huge">
            <Text.Header3 className="mb-s">
              {t('not_available.title')}
            </Text.Header3>
            <Text.BodyText3 tag="p" color="grey70">
              {t('not_available.description')}
            </Text.BodyText3>
          </div>
        </ContentLayout>
      </CmsLayout>
    )
  }

  // Safety check: if match is undefined, provide fallback
  const basePath = match?.path || '/brand_content/app_navigation'

  // This component now handles its own routing for AppNavigation sub-routes
  // Using match.path for nested routing pattern
  return (
    <>
      <NavConfirmModal />
      <RouterSwitch>
        {/* Editing routes - render directly, no layout */}
        <Route
          path={`${basePath}/bottom_nav/edit/:id`}
          exact
          component={BottomNavEdit}
        />

        {/* Default fallback - render nested RouterSwitch with layout */}
        <Route path={basePath}>
          <CmsLayout>
            <ContentLayout>
              <RouterSwitch>
                <Route path={`${basePath}/style`} exact>
                  <Style />
                </Route>
                <Route path={`${basePath}/hamburger_nav`} exact>
                  <HamburgerNav />
                </Route>
                <Route path={`${basePath}/bottom_nav`} exact>
                  <BottomNav />
                </Route>
                <Route path={basePath} exact>
                  <Style />
                </Route>
              </RouterSwitch>
            </ContentLayout>
          </CmsLayout>
        </Route>
      </RouterSwitch>
    </>
  )
}

export default AppNavigation
